// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterDesktop_root__3XFV5","item":"FooterDesktop_item__36AIB","icon":"FooterDesktop_icon__1V-JT","arrow":"FooterDesktop_arrow__2LKOz"};